(function (module) {
    'use strict';

    function MyAppsCtrl(utils, App, ListModifier, Includes, Store, $state, $mdDialog, Display, Group, Playlist) {
        this.setDefault = () => {
            this.loading = true;
            this.apps = null;
            this.selectedCount = 0;
            this.selected = null;
        };

        this.$onInit = () => {
            this.utils = utils;

            this.subAccountId = Store.getCurrentSubAccountId();
            this.setDefault();
            this.getData();
        };

        this.$onChanges = ({ subAccountId }) => {
            if (subAccountId) {
                this.$onDestroy();
                this.setDefault();
                this.getData();
            }
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.$onDestroy = () => {};

        this.getData = () => {
            App.find({ filter: Includes.apps }).$promise.then((response) => {
                this.loading = false;
                this.apps = Store.setMultiModelData('apps', response);
                this.updateUserApps();
            });
        };

        this.appSelectedCount = () => {
            this.selected = this.apps.filter((app) => app.checked === true);
            this.selectedCount = this.selected.length;
        };

        this.isChecked = (app) => {
            app.checked = !app.checked;
            this.appSelectedCount();
        };

        this.selectAll = () => {
            this.apps.forEach((app) => {
                app.checked = true;
            });
            this.appSelectedCount();
        };

        this.unselectAll = () => {
            this.apps.forEach((app) => {
                app.checked = false;
            });
            this.appSelectedCount();
        };

        this.updateUserApps = () => {
            this.groupedApps = _.groupBy(this.apps, 'appTemplateId');
        };

        this.findDisplaysUsingAppId = (appIds) => {
            if (!_.isArray(appIds)) appIds = [appIds];
            return Display.find({
                filter: {
                    where: { appId: { inq: appIds } },
                    fields: ['id'],
                },
            }).$promise;
        };

        this.findGroupsUsingAppId = (appIds) => {
            if (!_.isArray(appIds)) appIds = [appIds];
            return Group.find({
                filter: {
                    where: { appId: { inq: appIds } },
                    fields: ['id'],
                },
            }).$promise;
        };

        // this.findPlaylists = () => {
        //     return Playlist.find({
        //         filter: {
        //             fields: ['id', 'apps'],
        //         },
        //     }).$promise;
        // };

        this.findPlaylistsUsingAppId = (appIds) => {
            if (!_.isArray(appIds)) appIds = [appIds];
            return Playlist.find({
                filter: {
                    fields: ['id', 'apps'],
                },
            }).$promise.then((playlists) => {
                const playlistsUsingApp = [];
                playlists.forEach((playlist) => {
                    const playlistAppsIds = _.map(playlist.apps, 'id');
                    const intersection = _.intersection(playlistAppsIds, appIds);
                    if (intersection.length) {
                        playlistsUsingApp.push(playlist.id);
                    }
                });
                return playlistsUsingApp;
            });
        };

        this.cloneApp = (data) => {
            return App.create(data).$promise;
        };

        this.getAppById = (appId) => {
            return App.findById({ id: appId, filter: Includes.apps }).$promise;
        };

        this.clone = (id) => {
            const appToClone = Store.getSingleModelData('apps', id);
            if (!appToClone) {
                console.error('Error cloning app, cannot find app to clone');
            }

            const appToCreate = _.omit(appToClone.toJSON(), ['id', 'appTemplate', 'integration']);
            appToCreate.name = `${appToCreate.name} - copy`;
            this.cloneApp(appToCreate)
                .then(({ id }) => {
                    return this.getAppById(id);
                })
                .then((response) => {
                    return Store.setSingleModelData('apps', response.id, response);
                })
                .then(() => {
                    this.updateUserApps();
                })
                .catch((error) => {
                    console.error('Error cloning app, error from the API', error);
                });
        };

        this.deleteSelected = () => {
            const ids = _.chain(this.apps)
                .filter({ checked: true })
                .map((item) => item.id)
                .value();

            this.delete(ids);
        };

        this.delete = (id) => {
            Promise.all([this.findDisplaysUsingAppId(id), this.findGroupsUsingAppId(id), this.findPlaylistsUsingAppId(id)]).then(
                ([displaysUsingApp, groupsUsingApp, playlistsUsingApp]) => {
                    // const playlistsUsingApp = [];
                    //
                    // playlists.forEach((playlist) => {
                    //     playlist.apps.forEach((appInPlaylist) => {
                    //         if (appInPlaylist.id === id) {
                    //             playlistsUsingApp.push(playlist.name);
                    //         }
                    //
                    //     });
                    //
                    // });
                    const displaysUsingAppCount = displaysUsingApp && displaysUsingApp.length;
                    const groupsUsingAppCount = groupsUsingApp && groupsUsingApp.length;
                    const playlistsUsingAppCount = playlistsUsingApp.length;

                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;
                    let itemCount2;
                    let itemCount3;

                    if (displaysUsingAppCount <= 0 && groupsUsingAppCount <= 0 && playlistsUsingAppCount <= 0) {
                        modalTitle = 'Are you sure you want to permanently remove this app/apps?';
                        modalConfirmText = 'Confirm';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (id) => {
                            this.deleteById(id);
                        };
                    } else {
                        modalTitle = "You can't delete this app/apps as it is being used by :";

                        itemCount1 = displaysUsingAppCount > 0 ? `${displaysUsingAppCount + ' of your displays'}` : null;
                        itemCount2 = groupsUsingAppCount > 0 ? `${groupsUsingAppCount + ' of your groups'} ` : null;
                        itemCount3 = playlistsUsingAppCount > 0 ? `${playlistsUsingAppCount + ' of your playlists'}` : null;

                        modalConfirmationText = 'Please make sure the app is not being used before deleting it.';
                        modalCancelText = 'Ok, I understand';
                    }

                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: modalCancelText,
                            confirmText: modalConfirmText,
                            itemCount1: itemCount1,
                            itemCount2: itemCount2,
                            itemCount3: itemCount3,
                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };
                            $scope.confirm = () => {
                                $scope.cancel();
                                confirmActionFunc(id);
                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });
                },
            );
        };

        this.deleteById = (ids) => {
            if (!_.isArray(ids)) ids = [ids];

            return App.destroyAll({
                where: { id: { inq: ids } },
            })
                .$promise.then(() => {
                    _.remove(this.apps, (app) => _.indexOf(ids, app.id) >= 0);
                    this.updateUserApps();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.goToApp = (app) => {
            $state.go('root.my-apps.edit-app', { app: app, appId: app.id });
        };
    }

    module
        .config(function ($stateProvider, $translatePartialLoaderProvider) {
            $stateProvider.state('root.my-apps', {
                url: '/my-apps',
                data: {
                    pageTitle: 'PAGE_TITLE',
                },
                views: {
                    'content@root': {
                        template: '<my-apps-component sub-account-id="$ctrl.subAccountId" search="$ctrl.search"></my-apps-component>',
                    },
                },
                bodyClass: 'page--apps',
            });
            // Translations
            $translatePartialLoaderProvider.addPart('/js/my-apps');
        })
        .component('myAppsComponent', {
            templateUrl: '/js/my-apps/my-apps.html',
            controller: MyAppsCtrl,
            bindings: {
                search: '<search',
                subAccountId: '<',
            },
        });
})(angular.module('rocket.components'));
